import { createNamespacedHelpers } from 'vuex';
import ChannelDefs from '@/store/channel/channel.d';
import ChannelItem from '@/components/channel_item/ChannelItem';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import subscription from '@/api/subscription';

const { mapActions: mapChannelActions } = createNamespacedHelpers('Channel');

export default {
  name: 'UserList',
  components: { ChannelItem, LoadingDots },
  props: {
    userList: Array,
    keyword: String,
    isLoading: Boolean
  },
  data: () => ({
    premiumRecords: {},
    currentChannelUrl: ''
  }),
  watch: {
    userList() {
      const userIds = this.userList.map((item) => item.userId);
      subscription.getSubscriptionByUsers(userIds).then((response) => {
        this.premiumRecords = Object.assign(
          {},
          this.premiumRecords,
          response || {}
        );
      });
    }
  },
  methods: {
    ...mapChannelActions({
      channelStore_joinChannel: ChannelDefs.actions.joinChannel
    }),

    joinChannel: async function (channelUrl, userId) {
      await this.channelStore_joinChannel({
        channel: { channel_url: channelUrl },
        sender: { user_id: userId }
      });
    }
  }
};
